<template>
  <input
    type="text"
    class="core-form-input"
    :value="renderedValue"
    :disabled="disabled"
    :placeholder="placeholder"
    @input.prevent="onInput"
    @blur.prevent="onBlur($event)"
    @keydown="onlyNumbers($event)" />
</template>

<script lang="ts" setup>
import { formatCHFWithCents, formatNumberWithThousandSeparators } from '@/helpers/format'
import { computed, type PropType } from 'vue'

const modelValue = defineModel({ type: [Number, null] as unknown as PropType<number | null> })

const props = defineProps<{
  placeholder?: string
  disabled?: boolean
  formatCHF?: boolean
  formatBigNumber?: boolean
  maxLength?: number
}>()

const renderedValue = computed(() => {
  if (modelValue.value) {
    if (props.formatCHF) {
      return formatCHFWithCents(modelValue.value)
    }
    if (props.formatBigNumber) {
      return formatNumberWithThousandSeparators(modelValue.value)
    }
  }
  return modelValue.value
})

function onlyNumbers(event: KeyboardEvent): boolean | void {
  const allowed: string = '0123456789'
  const keyPressed: string = event.key
  const allowedKeys = ['Delete', 'Backspace', 'ShiftLeft', 'ShiftRight', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End']
  if (!allowed.includes(keyPressed) && !allowedKeys.includes(event.key)) {
    event.preventDefault()
    return
  }
  if (props.maxLength && allowed.includes(keyPressed)) {
    const target = event.target as HTMLInputElement
    const rawValue = target.value.replaceAll("'", '')
    if (rawValue.length >= props.maxLength) {
      event.preventDefault()
    }
  }
  return true
}

function onInput(event: Event) {
  onBlur(event)
}

function onBlur(event: Event) {
  const target = event.target as HTMLInputElement
  const value = parseInt(target.value.replaceAll("'", ''))
  if (isNaN(value)) {
    modelValue.value = null
  } else {
    modelValue.value = value
  }
}
</script>
